export const buildReservationKey = (index, reservation) => {
  if (reservation.nanoId) return reservation.nanoId

  const baseKey = `${reservation.from}-${index}-${reservation.to}-${reservation.rate?.id}`

  return reservation.site?.id ? `${baseKey}-${reservation.site.id}` : baseKey
}
